export default __webpack_public_path__ + "static/media/history-featured-image.f9f065ba.jpg";